import React, { ReactElement } from "react";

type Props = {
  children: ReactElement | ReactElement[];
};

export default function PanelContent(props: Props): ReactElement {
  const { children } = props;

  return (
    <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
      {children}
    </div>
  );
}
